<div class="right-side right-side-bg p-5">
  <h2>Dashboard</h2>
  <div>
    <div class="card mb-3">
      <div class="card-header"><h2>Proposal</h2></div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-3 mb-2" id="btnTotalProposal" (click)="CardRedirection($event)">
            <div class="card bg-gradient-primary box-shadow dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Total Proposal</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{ totalProposal }}</div>
                  <i class="bi bi-file-earmark-text ms-auto fs-4"></i>
                </div>
                <p class="card-text fnts">Total No. of proposal submitted for approval.</p>
              </div>
            </div>
          </div>



          <div class="col-md-3 mb-2" id="btnApprovedProposal" (click)="CardRedirection($event)">
            <div class="card bg-gradient-success box-shadow dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Approved Proposal</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{ approvedProposal }}</div>
                  <i class="bi bi-check-circle ms-auto fs-4"></i>
                </div>
                <p class="card-text fnts">No. of proposal that have been approved.</p>
              </div>
            </div>
          </div>

          <div class="col-md-3 mb-2" id="btnPendingProposal" (click)="CardRedirection($event)">
            <div class="card bg-gradient-warning box-shadow dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Pending Proposal</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{ pendingProposal }}</div>
                  <i class="bi bi-question-circle ms-auto fs-4"></i>
                </div>
                <p class="card-text fnts">No. of proposal awaiting verification.</p>
              </div>
            </div>
          </div>

          <div class="col-md-3 mb-2" id="btnRejectedProposal" (click)="CardRedirection($event)">
            <div class="card bg-gradient-danger box-shadow dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Rejected Proposal</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{ rejectedProposal }}</div>
                  <i class="bi bi-file-earmark-x ms-auto fs-4"></i>
                </div>
                <p class="card-text fnts">No. of proposal that have been rejected.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-header"> <h2>Events</h2></div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-3 mb-2" id="btnTotalEvents" (click)="CardRedirection($event)">
            <div class="card bg-gradient-primary box-shadow dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Total Events</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{ totalEvents }}</div>
                  <i class="bi bi-file-earmark-text ms-auto fs-4"></i>
                </div>
                <p class="card-text fnts">Total No. of Events that have been created.</p>
              </div>
            </div>
          </div>
          <div class="col-md-3" id="btnCompletedEvents" (click)="CardRedirection($event)">
            <div class="card bg-gradient-warning box-shadow mb-2 dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Completed Events</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{ completedEvents }}</div>
                  <i class="bi bi-check-circle ms-auto fs-4"></i>
                </div>
                <p class="card-text fnts">No. of Events that have been completed.</p>
              </div>
            </div>
          </div>
          <div class="col-md-3" id="btnUpcomingEvents" (click)="CardRedirection($event)">
            <div class="card bg-gradient-success box-shadow mb-2 dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Upcoming Events</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{ upcomingEvents }}</div>
                  <i class="bi bi-check-circle ms-auto fs-4"></i>
                </div>
                <p class="card-text fnts">No. of Events that have been scheduled.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--<div class="card mb-3">
      <div class="card-header"> <h2>MSME</h2></div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-3 mb-2" id="btnAllMSME" (click)="CardRedirection($event)">
            <div class="card bg-gradient-primary box-shadow">
              <div class="card-body">
                <h5 class="card-title fs-5">Total Registered MSME </h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{ totalMSME }}</div>
                  <i class="bi bi-file-earmark-text ms-auto fs-4"></i>
                </div>
                <p class="card-text fnts">Total No. of Registered MSME .</p>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>-->

    <div class="card mb-3">
      <div class="card-header"> <h2>On The Spot Users</h2></div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-3 mb-2" id="btnRegOnSpot" (click)="CardRedirection($event)">
            <div class="card bg-gradient-primary box-shadow dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Registered MSME </h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{ totalRegisteredOnspot }}</div>
                  <i class="bi bi-file-earmark-text ms-auto fs-4"></i>
                </div>
                <p class="card-text fnts">Total No. of Registered MSME .</p>
              </div>
            </div>
          </div>
          <div class="col-md-3" id="btnUnRegOnSpot" (click)="CardRedirection($event)">
            <div class="card bg-gradient-warning box-shadow mb-2 dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Unregistered MSME  </h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{ totalUnRegisteredOnspot }}</div>
                  <i class="bi bi-check-circle ms-auto fs-4"></i>
                </div>
                <p class="card-text fnts">Total No. of UnRegistered MSME .</p>
              </div>
            </div>
          </div>

          <!--<div class="col-md-3 mssdc-mt" id="btnUpcomingEvents" (click)="CardRedirection($event)">
        <div class="card bg-gradient-success box-shadow mb-2">
          <div class="card-body">
            <h5 class="card-title fs-5">Upcoming Events</h5>
            <div class="d-flex align-items-center">-->
          <!--<div class="fs-5">{{ upcomingEvents }}</div>-->
          <!--<i class="bi bi-check-circle ms-auto fs-4"></i>
              </div>
              <p class="card-text fnts">No. of Events that have been scheduled.</p>
            </div>
          </div>
        </div>-->
          <!--</div>
          </div>
        </div>-->





        </div>
      </div>


    </div>
    <!--<div class="card mb-3">
    <div class="card-header"><h2>Grievance</h2></div>
    <div class="card-body">-->
    <!-- Event Section -->
    <!--<div class="row">
    <div class="col-md-3">
      <div class="card bg-gradient-primary box-shadow mb-2">
        <div class="card-body">
          <h5 class="card-title fs-5">Total</h5>
          <div class="d-flex align-items-center">
            <div class="fs-5">{{totalGrievances}}</div>
          </div>
          <p class="card-text mt-2">
            <button id="btnTotalGrievances" class="btn-link bg-transparent border-0 text-white" (click)="CardRedirection($event)">-->
    <!--<i class="bi bi-calendar-event ms-auto fs-4"></i>-->
    <!--<i class="bi bi-person-plus ms-auto fs-4"></i>-->
    <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
    <!--</button>
          </p>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="card bg-gradient-success box-shadow mb-2">
        <div class="card-body">
          <h5 class="card-title fs-5">Disposed</h5>
          <div class="d-flex align-items-center">
            <div class="fs-5">{{disposedGrievances}}</div>
          </div>
          <p class="card-text mt-2">
            <button id="btnDisposedGrievances" class="btn-link bg-transparent border-0 text-white" (click)="CardRedirection($event)">-->
    <!--<i class="bi bi-calendar-check ms-auto fs-4"></i>-->
    <!--<i class="bi bi-check-circle ms-auto fs-4"></i>-->
    <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
    <!--</button>
          </p>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="card bg-gradient-warning box-shadow mb-2">
        <div class="card-body">
          <h5 class="card-title fs-5">Pending</h5>
          <div class="d-flex align-items-center">
            <div class="fs-5">{{pendingGrievances}}</div>
          </div>
          <p class="card-text mt-2">
            <button id="btnPendingGrievances" class="btn-link bg-transparent border-0 text-white" (click)="CardRedirection($event)">
              <i class="bi bi-hourglass ms-auto fs-4"></i>-->
    <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
    <!--</button>
          </p>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="card bg-gradient-danger box-shadow mb-2">
        <div class="card-body">
          <h5 class="card-title fs-5">Rejected</h5>
          <div class="d-flex align-items-center">
            <div class="fs-5">{{rejectedGrievances}}</div>
          </div>
          <p class="card-text mt-2">
            <button id="btnRejectedGrievances" class="btn-link bg-transparent border-0 text-white" (click)="CardRedirection($event)">
              <i class="bi bi-x-circle ms-auto fs-4"></i>-->
    <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
    <!--</button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>-->



    <!--*****************************************Commented for 1st live**********************************************************-->
    <!--<div class="card mb-3">
      <div class="card-header"> <h2>Grievance</h2></div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-3 mb-2" id="btnTotalGrievances" (click)="CardRedirection($event)">
            <div class="card bg-gradient-primary box-shadow dash-height">
              <div class="card-body">
                <h5 class="card-title fs-5">Total</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{ totalGrievances }}</div>
                  <i class="bi bi-person-plus ms-auto fs-4"></i>
                </div>
                <p class="card-text fnts">Total number of grievances received.</p>
              </div>
            </div>
          </div>
          <div class="col-md-3 mb-2" id="btnDisposedGrievances" (click)="CardRedirection($event)">
            <div class="card bg-gradient-success box-shadow dash-height">
              <div class="card-body">
                <h5 class="card-title fs-5">Disposed</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{ disposedGrievances }}</div>
                  <i class="bi bi-check-circle ms-auto fs-4"></i>
                </div>
                <p class="card-text fnts">Grievances that have been resolved.</p>
              </div>
            </div>
          </div>
          <div class="col-md-3 mb-2" id="btnPendingGrievances" (click)="CardRedirection($event)">
            <div class="card bg-gradient-warning box-shadow dash-height">
              <div class="card-body">
                <h5 class="card-title fs-5">Pending</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{ pendingGrievances }}</div>
                  <i class="bi bi-hourglass ms-auto fs-4"></i>
                </div>
                <p class="card-text fnts">Grievances that are yet to be resolved.</p>
              </div>
            </div>
          </div>
          <div class="col-md-3 mb-2" id="btnRejectedGrievances" (click)="CardRedirection($event)">
            <div class="card bg-gradient-danger box-shadow dash-height">
              <div class="card-body">
                <h5 class="card-title fs-5">Rejected</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{ rejectedGrievances }}</div>
                  <i class="bi bi-x-circle ms-auto fs-4"></i>
                </div>
                <p class="card-text fnts">Grievances that have been rejected.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>-->

  </div>
</div>
